var ScoutingReportGameStatsController = (function () {
    function ScoutingReportGameStatsController($q, GameService, GameUtils) {
        this.$q = $q;
        this.GameService = GameService;
        this.GameUtils = GameUtils;
    }
    ScoutingReportGameStatsController.prototype.$onChanges = function (changes) {
        var changesReport = _.get(changes, 'report.currentValue');
        var changesPlayer = _.get(changes, 'selectedPlayer.currentValue');
        if (changesReport && changesPlayer) {
            this.ts = Date.now();
            this.fetchStats(changesReport, changesPlayer, this.ts);
        }
        else if (changesReport) {
            this.ts = Date.now();
            this.fetchStats(changesReport, this.selectedPlayer, this.ts);
        }
        else if (changesPlayer) {
            this.ts = Date.now();
            this.fetchStats(this.report, changesPlayer, this.ts);
        }
    };
    ScoutingReportGameStatsController.prototype.fetchStats = function (report, selectedPlayer, ts) {
        var _this = this;
        this.playerGameStats = null;
        if (!report.game || !selectedPlayer) {
            this.$promise = this.$q.resolve();
            return;
        }
        this.$promise = this.GameService.getPlayerStats(selectedPlayer.player._id, {
            isSkater: this.isSkater(selectedPlayer.player),
            dates: moment(report.game.date).utc().format('YYYY-MM-DD'),
        }).then(function (stats) {
            if (ts !== _this.ts) {
                return;
            }
            var playerGameStats = stats[0];
            if (!playerGameStats) {
                return;
            }
            _this.playerGameStats = playerGameStats;
        });
    };
    ScoutingReportGameStatsController.prototype.isSkater = function (player) {
        return player && player.playerPosition !== 'GOALIE';
    };
    ScoutingReportGameStatsController.prototype.playEvents = function (_a) {
        var _this = this;
        var $gameEvents = _a.$gameEvents, $title = _a.$title, $key = _a.$key;
        if (!this.playerGameStats) {
            return;
        }
        var gameTitle = "".concat(this.playerGameStats.date, ". ").concat(this.playerGameStats.home.name, " - ").concat(this.playerGameStats.away.name);
        var playerName = "".concat(this.playerGameStats.playerStat.fullName, " (").concat(this.playerGameStats.playerStat.jerseyNumber, ")");
        var title = "".concat(gameTitle, " // ").concat(playerName, " // ").concat($title);
        this.loadingKey = $key;
        var eventIds = $gameEvents.map(function (evt) { return _this.GameUtils.extractStatEvents(evt).eventId; });
        this.GameService.fetchGameEvents(eventIds)
            .then(function (gameEvents) {
            _this.GameService.checkStaleEventData(eventIds, gameEvents);
            _this.GameService.openVirtualClipViewer(title, gameEvents);
        })
            .finally(function () {
            _this.loadingKey = '';
        });
    };
    ScoutingReportGameStatsController.prototype.isPlayable = function (statName) {
        var _this = this;
        return (!!this.playerGameStats.isVideoAvailable &&
            this.playerGameStats.playerStat.events[statName] &&
            this.playerGameStats.playerStat.events[statName].length > 0 &&
            this.playerGameStats.playerStat.events[statName].some(function (evt) { return _this.GameUtils.extractStatEvents(evt).isPlayable; }));
    };
    return ScoutingReportGameStatsController;
}());
angular.module('app.scouting').component('scoutingReportGameStats', {
    templateUrl: 'scouting/components/report/game-stats.html',
    controller: ScoutingReportGameStatsController,
    bindings: {
        report: '<',
        selectedPlayer: '<',
    },
});